import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './table-cell-simple.scss?inline';

export default class SotbitTableCellSimple extends LitElement {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    render() {
        return html`<slot></slot>`;
    }
}
